import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum UmbilicusEnum {
    Healed = 1 as any,
    Hernia = 2 as any,
    Inverted = 4 as any,
    Everted = 8 as any
}

class UmbilicusClass extends EnumWithDescription<UmbilicusEnum> {
    public readonly enum = UmbilicusEnum;
    public readonly enumName: string = "UmbilicusEnum";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<UmbilicusEnum>> = new Map([
        [
            "Healed",
            {
                value: UmbilicusEnum.Healed,
                name: "Healed"
            }
        ],
        [
            "Hernia",
            {
                value: UmbilicusEnum.Hernia,
                name: "Hernia"
            }
        ],
        [
            "Inverted",
            {
                value: UmbilicusEnum.Inverted,
                name: "Inverted"
            }
        ],
        [
            "Everted",
            {
                value: UmbilicusEnum.Everted,
                name: "Everted"
            }
        ]
    ]);
}

export const Umbilicus = new UmbilicusClass();
